/**
 * Checks to see if and image has a height and width
 * @param {String} imageUrl the image url to perform check
 * @returns {Boolean} returns true if the image has a heigth or width, otherwise return false
 */
export default function(imageUrl) {
  if (imageUrl) {
    const image = new Image();

    image.src = imageUrl;
    if (image.naturalHeight + image.naturalWidth === 0) {
      return false;
    } else if (image.height + image.width === 0) {
      return false;
    }
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/imageChecker.js